import React from 'react';

import styles from './Description.module.css';

const Description = ({ value, expendDescription }) => {
    const selectStyles = [styles.desc];
    if (expendDescription) {
        selectStyles.push(styles.wide);
    }

    return <div className={selectStyles.join(' ')}
    >{value}</div>;
};

export default React.memo(Description);
